import {generateInitialState} from "@/helpers/generateInitialState";
import {biomarkersInitialState} from "@/features/initialStates";
import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {loadBiomarkersInformation} from "./biomarkersActions";

const initialState = await generateInitialState("biomarkers", biomarkersInitialState);

const biomarkersSlice = createSlice({
  name: "biomarkers",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadBiomarkersInformation.fulfilled, (state, action) => {
        state.data = [...action.payload];
        state.isFetching = false;
        state.hasFailed = false;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadBiomarkersInformation.pending), (state, action) => {
        state.isFetching = true;
        state.hasFailed = false;
        state.errorMsg = "";
      })
      .addMatcher(isAnyOf(loadBiomarkersInformation.rejected), (state, action) => {
        const {message = "Something went wrong"} = action.payload || {};

        state.isFetching = false;
        state.hasFailed = true;
        state.errorMsg = message;
      });
  },
  selectors: {
    biomarkersDataSelector: state => state.data,
  },
});

export const {} = biomarkersSlice.actions;
export const {biomarkersDataSelector} = biomarkersSlice.selectors;
export default biomarkersSlice.reducer;
